"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNumberAdapter = void 0;
const event_callback_hook_1 = require("./event-callback-hook");
function useNumberAdapter(value, onChange) {
    const stringValue = value != null ? String(value) : '';
    const handleChange = (0, event_callback_hook_1.useEventCallback)((value) => {
        onChange(value != '' ? Number(value) : null);
    });
    return { value: stringValue, onChange: handleChange };
}
exports.useNumberAdapter = useNumberAdapter;
//# sourceMappingURL=number-adapter-hook.js.map